import { useAct } from 'FlowBuilder/store'
import useGenericTranslate from './useGenericTranslateFlow';
import { FlowTranslatableKeys, flowTranslatables } from 'FlowBuilder/lib/flowTranslatable';
import { Translatable } from 'Shared/TranslatableTextContent/translatable';

export default function useFlowTranslate<T extends string | number | symbol = FlowTranslatableKeys>({ languageOverride = null } = {}) {
  const act = useAct();

  const flow = useSel(s => s.taker?.flow || s.builder?.flow || {})
  const flowTemplateFields = flow?.template?.fields || {}
  
  const flowTemplateFieldsTranslatableConfig = Object.keys(flowTemplateFields).reduce((acc, key) => {
    const field = flowTemplateFields[key]
    if (field.translatable) {
      acc[_.camelCase(field.slug)] = {
        label: field.label,
        default: field.defaultValue,
        html: !!field.wysiwyg,
      }
    }
    return acc
  }, {} as Record<string, Translatable>)

  const {language, translated, fallback, flag} = useGenericTranslate<T>({ textContent: flow.textContent, languageOverride, translatableConfiguration: {...flowTemplateFieldsTranslatableConfig, ...flowTranslatables} })

  function textContentUpdater(key: T, value: string) {
    act.builder.updateFlowTextContent(language, key, value)
  }
  
  return {
    language,
    translated,
    fallback,
    textContentUpdater,
    flag
  }
}

